import {
  UPGRADE_REPORT_API,
} from 'constants/AppConstants';

export default async (upgradedReportId) => {
  try {
    const response = await fetch(`${UPGRADE_REPORT_API}/${upgradedReportId}/upgraded-report`);
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
